export default __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmSU5fChc4EsA.woff2";